import {NgModule} from '@angular/core';
import {AdminPageComponent} from './pages/admin-page/admin-page.component';
import {TermwebStatusComponent} from './components/termweb-status/termweb-status.component';
import {ConfigurationListComponent} from './components/configuration-list/configuration-list.component';
import {EditConfigurationFormComponent} from './components/edit-configuration-form/edit-configuration-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ComponentEditorsListComponent} from './components/component-editors-list/component-editors-list.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {AdminRoutingModule} from './admin-routing.module';
import {ConfigurationsPanelComponent} from './components/configurations-panel/configurations-panel.component';
import {SettingsPanelComponent} from './components/settings-panel/settings-panel.component';
import {DictionariesPanelComponent} from './components/dictionaries-panel/dictionaries-panel.component';
import {SyncStatusIndicatorComponent} from './components/sync-status-indicator/sync-status-indicator.component';
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';
import {IconButtonComponent} from './components/icon-button/icon-button.component';
import {AdminHomeComponent} from './components/admin-home/admin-home.component';
import {DictionaryDetailsComponent} from './components/dictionary-details/dictionary-details.component';
import {SectionsPanelComponent} from './components/sections-panel/sections-panel.component';
import {DatePipe} from '@angular/common';
import {LanguagesPanelComponent} from './components/languages-panel/languages-panel.component';
import {ScheduledSyncSettingsComponent} from './components/scheduled-sync-settings/scheduled-sync-settings.component';
import {
  TermwebConnectionSettingsComponent
} from './components/termweb-connection-settings/termweb-connection-settings.component';
import {UploadDialogComponent} from './components/confirm-dialog/upload-dialog/upload-dialog.component';
import {
  TermwebConnectionSettingsFormComponent
} from './components/termweb-connection-settings-form/termweb-connection-settings-form.component';
import {
  TermwebConnectionSettingsDisplayComponent
} from './components/termweb-connection-settings-display/termweb-connection-settings-display.component';
import {CompeditorModule} from './components/compeditor/compeditor.module';
import {MaterialModule} from '@twpub/shared/material/material.module';
import {TermwebStatusTextComponent} from './components/termweb-status-text/termweb-status-text.component';
import {SearchableFieldsPanelComponent} from './components/searchable-fields-panel/searchable-fields-panel.component';
import {CssVariablesEditorComponent} from './components/css-variables-editor/css-variables-editor.component';
import {FontUploadComponent} from './components/font-upload/font-upload.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSortModule} from '@angular/material/sort';

@NgModule({
  imports: [
    SharedModule, AdminRoutingModule, CompeditorModule, FormsModule, ReactiveFormsModule, RouterModule, MaterialModule,
    MatProgressBarModule, MatSortModule,
    AdminPageComponent, TermwebStatusComponent, ConfigurationListComponent, EditConfigurationFormComponent,
    ComponentEditorsListComponent, ConfigurationsPanelComponent, SettingsPanelComponent, DictionariesPanelComponent,
    SyncStatusIndicatorComponent, ConfirmDialogComponent, IconButtonComponent, AdminHomeComponent,
    DictionaryDetailsComponent, SectionsPanelComponent, LanguagesPanelComponent, ScheduledSyncSettingsComponent,
    TermwebConnectionSettingsComponent, UploadDialogComponent, TermwebConnectionSettingsFormComponent,
    TermwebConnectionSettingsDisplayComponent, TermwebStatusTextComponent, SearchableFieldsPanelComponent,
    CssVariablesEditorComponent, FontUploadComponent
  ],
  providers: [DatePipe]
})
export class AdminModule {
}
